import { render, staticRenderFns } from "./CustomerClaimCorrespondenceList.vue?vue&type=template&id=fbfa20b2&"
import script from "./CustomerClaimCorrespondenceList.vue?vue&type=script&lang=js&"
export * from "./CustomerClaimCorrespondenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports